// extracted by mini-css-extract-plugin
export default {"container":"SubHero_container__6kP3v","content":"SubHero_content__Y8faW","card":"SubHero_card__Fv8TJ"};